<p-table [value]="resRevenues" sortMode="multiple" [responsive]="true" styleClass="p-datatable-striped"
  responsiveLayout="scroll" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" responsiveLayout="scroll"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,100,250]">

  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [style.white-space]="'nowrap'">
          {{col.header}}<p-sortIcon [field]="col.header"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      @for (col of columns; track col) {
        <!--** Special: date field-->
        @if (col.field==='date') {
          <td>
            {{rowData[col.field]  | date:'shortDate' }}
          </td>
        }
        <!--** Special: resStatus field-->
        @if (col.field==='resStatus') {
          <td [style.background-color]="getResStatusColor(rowData[col.field])">
            {{getResStatusName(rowData[col.field])}}
          </td>
        }
        <!--** Special: location field-->
        @if (col.field==='locationId') {
          <td [style.color]="getLocationColor(rowData[col.field])">
            {{getLocationName(rowData[col.field])}}
          </td>
        }
        <!--** Special: channel image field-->
        @if (col.field==='refSrcId') {
          <td>
            <img width="80px" height="auto" src='{{getRefSrcImage(rowData[col.field])}}'>
          </td>
        }
        <!--** Special: channel image field-->
        @if (col.field==='guestLastName') {
          <td>
            <a [routerLink]="" (click)="showResRevDetail(rowData)">{{rowData[col.field]	}}</a>
          </td>
        }
        @if (col.type==='str') {
          <td>
            {{rowData[col.field]}}
          </td>
        }
        @if (col.type==='num') {
          <td>
            {{rowData[col.field]}}
          </td>
        }
        @if (col.type==='cur') {
          <td>
            {{rowData[col.field] | currency}}
          </td>
        }
        @if (col.type==='pct') {
          <td>
            {{rowData[col.field] | percent}}
          </td>
        }
        @if (col.type==='date') {
          <td>
            {{rowData[col.field] | date:'shortDate'}}
          </td>
        }
        @if (col.type==='time') {
          <td>
            {{rowData[col.field]  | date:'shortTime'}}
          </td>
        }
        @if (col.type==='timestamp') {
          <td>
            {{rowData[col.field]  | date:'short'}}
          </td>
        }
      }
    </tr>
  </ng-template>
</p-table>